import { METHOD, request } from '@/utils/request';
import { PRODUCT_CATEGORY_FIND } from './api';
export function ProductCategoryFind(stage) {
  return request(PRODUCT_CATEGORY_FIND, METHOD.POST, { stage });
}
